import { useCallback, useMemo } from 'react';
import { getTierRangesAndPricesForCurrency } from 'tiered-pricing/utils/pricing';
import { LINE_ITEM_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { usePaginatedData } from '../../../hooks/usePaginatedData';
import { useHomeCurrency } from '../../../v2/hooks/useHomeCurrency';
import { useObjectTypeId } from '../../../v2/hooks/useObjectTypeId';
import { DEFAULT_PAGE_SIZE } from '../constants/pages';
import { useGetTierRangesAndPrices } from '../hooks/useGetTierRangesAndPrices';
import { TieredPriceModalPaginationSection } from './TieredPriceModalPaginationSection';
import { TieredPriceTable } from './TieredPriceTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TieredPriceModalTableSection = ({
  currencyCode,
  pricingModel
}) => {
  var _tierRangesAndPricesF;
  const objectTypeId = useObjectTypeId();
  const tierRangesAndPrices = useGetTierRangesAndPrices();
  const tierRangesAndPricesForCurrency = getTierRangesAndPricesForCurrency(tierRangesAndPrices,
  // Line Items don't have a currency code on tier prices
  objectTypeId === LINE_ITEM_TYPE_ID ? undefined : currencyCode);
  const totalTiersCount = (_tierRangesAndPricesF = tierRangesAndPricesForCurrency === null || tierRangesAndPricesForCurrency === void 0 ? void 0 : tierRangesAndPricesForCurrency.length) !== null && _tierRangesAndPricesF !== void 0 ? _tierRangesAndPricesF : 0;
  const [paginatedTierRangesAndPrices, {
    itemsPerPage,
    numPages,
    offset,
    pageIndex,
    setItemsPerPage,
    setPageIndex
  }] = usePaginatedData(tierRangesAndPricesForCurrency !== null && tierRangesAndPricesForCurrency !== void 0 ? tierRangesAndPricesForCurrency : [], DEFAULT_PAGE_SIZE);
  const handlePageChange = useCallback(({
    target: {
      value: newPage
    }
  }) => {
    setPageIndex(newPage);
  }, [setPageIndex]);
  const currentTiersCount = Math.min(offset, totalTiersCount);
  const {
    data: homeCurrencyCode
  } = useHomeCurrency();
  const effectiveCurrencyCode = useMemo(() => {
    if (currencyCode === undefined && homeCurrencyCode === undefined) {
      return undefined;
    }
    return currencyCode !== null && currencyCode !== void 0 ? currencyCode : homeCurrencyCode;
  }, [currencyCode, homeCurrencyCode]);

  // Satisfies TS but this step should never be reached as the View Tiers button should have been disabled
  if (effectiveCurrencyCode === undefined) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TieredPriceTable, {
      tierRangesAndPrices: paginatedTierRangesAndPrices,
      pricingModel: pricingModel,
      currencyCode: effectiveCurrencyCode
    }), /*#__PURE__*/_jsx(TieredPriceModalPaginationSection, {
      currentPage: pageIndex,
      currentTiersCount: currentTiersCount,
      itemsPerPage: itemsPerPage,
      onPageChange: handlePageChange,
      numPages: numPages,
      setItemsPerPage: setItemsPerPage,
      totalTiersCount: totalTiersCount
    })]
  });
};